import { serverAppConfig, serverTheme } from './server-app-config'
import { AppConfig, AppConfigBase, AppConfigTheme, SiteMetaData } from 'ecosystem'
import manifest from '../../public/manifest.json'
import { server } from '../custom/api/server'
import { Metadata } from 'next'
import { stdCanonicalFactory } from 'shared-utils'

const typedServerConfig = serverAppConfig as unknown as AppConfigBase
const typedServerTheme = serverTheme as unknown as AppConfigTheme

const siteMetadata: SiteMetaData = {
  title: manifest.name,
  description: manifest.description,
  image: `${typedServerConfig.logoUrl}`,
  url: server!,
  keywords: []
}

export const appConfig: AppConfig = {
  ...typedServerConfig,
  site: siteMetadata,
  theme: typedServerTheme
}

type MetadataFactory = Metadata & {
  pathname: string
  title?: string
  description?: string
  images?: string[]
  keywords?: string[]
  /**
   * Site-level metadata to base this on. Defaults to the static build-time
   * `siteMetadata`; pass `appConfig.site` from `getDynamicAppConfig()` so the
   * OG/Twitter image follows the live store logo without a redeploy.
   */
  site?: SiteMetaData
}
export const metadataFactory = ({
  title,
  description,
  images,
  pathname,
  keywords,
  site = siteMetadata,
  ...rest
}: MetadataFactory): Metadata => {
  // https://github.com/vercel/next.js/issues/35345
  const path = pathname?.replace(/^\/index/, '/')
  const completeUrl = `${site.url}${path}`

  return {
    title: `${title || site.title} - ${site.title}`,
    description: description || site.description,
    keywords: [...site.keywords, ...(keywords ? keywords : [])],
    openGraph: {
      url: completeUrl,
      type: 'website',
      title: `${title || site.title} - ${site.title}`,
      description: description || site.description,
      images: [site.image, ...(images ? images : [])]
    },
    twitter: {
      title: `${title || site.title} - ${site.title}`,
      description: description || site.description,
      card: 'summary_large_image',
      images: [site.image, ...(images ? images : [])]
    },
    alternates: {
      canonical: stdCanonicalFactory(path, server)
    },
    ...rest
  }
}
